// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3zQCZ","inputWrap":"Table_inputWrap__1DAyc","col":"Table_col__y_mFG","bmiTooltip":"Table_bmiTooltip__39-G7"};